import { loginRequest, getProfile } from "../services/authService";

export function useAuth() {
  async function login(username, password) {
    const data = await loginRequest(username, password);

    // Clear previous session's condominio context before setting new one
    localStorage.removeItem("condominioId");
    localStorage.removeItem("active_condominio_id");
    localStorage.removeItem("condominios_contador");
    localStorage.removeItem("multimoneda_activa");

    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);

    const perfil = await getProfile();
    const uc  = perfil?.usuario_condominio;
    const rol = uc?.rol || "USUARIO";

    localStorage.setItem("is_superuser", perfil?.is_superuser ? "true" : "false");
    localStorage.setItem("rol", rol);

    if (rol === "CONTADOR") {
      const condominios = uc?.condominios_contador || [];
      localStorage.setItem("condominios_contador", JSON.stringify(condominios));
      // Restore last selected condominio or default to first
      const savedId  = localStorage.getItem("active_condominio_id");
      const validIds = condominios.map(c => String(c.id));
      if (!savedId || !validIds.includes(savedId)) {
        if (condominios.length > 0) {
          localStorage.setItem("active_condominio_id", String(condominios[0].id));
        }
      }
    } else {
      const condominioId = uc?.condominio?.id;
      if (condominioId) {
        localStorage.setItem("condominioId", String(condominioId));
      }
      const multimoneda = uc?.condominio?.multimoneda_activa ?? false;
      localStorage.setItem("multimoneda_activa", multimoneda ? "true" : "false");
    }

    return data;
  }

  function logout() {
    localStorage.clear();
    window.location.href = "/login";
  }

  function isAuthenticated() {
    const token = localStorage.getItem("access_token");
    const refresh = localStorage.getItem("refresh_token");
    return Boolean(token && refresh);
  }

  return { login, logout, isAuthenticated };
}
